var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1654 7.33268C12.1654 9.99935 7.9987 12.8327 7.9987 12.8327C7.9987 12.8327 3.83203 9.99935 3.83203 7.33268C3.83203 4.99935 5.78956 3.16602 7.9987 3.16602C10.2078 3.16602 12.1654 4.99935 12.1654 7.33268Z",
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 7.33268C9.4987 8.16111 8.82712 8.83268 7.9987 8.83268C7.17027 8.83268 6.4987 8.16111 6.4987 7.33268C6.4987 6.50426 7.17027 5.83268 7.9987 5.83268C8.82712 5.83268 9.4987 6.50426 9.4987 7.33268Z",
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.43b416ad97127c18509d1f8823f8eab4.svg";
export { ForwardRef as ReactComponent };